if (!customElements.get('doen-product-tile-gallery')) {
  customElements.define(
    'doen-product-tile-gallery',
    class DoenProductTileGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.mobileMediaQuery = window.matchMedia('(max-width: 999px)');
        this.link = this.closest('.doen-column')?.querySelector('[data-product-tile-gallery-link]');
        this.onViewportChange = this.onViewportChange.bind(this);

        this.link?.addEventListener('pointerdown', (event) => this.onPointerDown(event));
        this.link?.addEventListener('pointerup', (event) => this.onPointerUp(event));
        this.link?.addEventListener('pointercancel', () => this.resetPointer());
        this.link?.addEventListener('click', (event) => this.onLinkClick(event));
        this.link?.addEventListener('touchstart', (event) => this.onDragStart(event), { passive: true });
        this.link?.addEventListener('mousedown', (event) => this.onDragStart(event));
        this.mobileMediaQuery.addEventListener('change', this.onViewportChange);

        this.showImage(0);
      }

      disconnectedCallback() {
        this.mobileMediaQuery?.removeEventListener('change', this.onViewportChange);
      }

      onPointerDown(event) {
        if (
          !this.mobileMediaQuery.matches ||
          event.isPrimary === false ||
          !this.isPointWithinGallery(event)
        ) {
          return;
        }

        this.pointerStart = {
          x: event.clientX,
          y: event.clientY,
        };
      }

      onPointerUp(event) {
        if (!this.mobileMediaQuery.matches || !this.pointerStart) {
          this.resetPointer();
          return;
        }

        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        const swipeThreshold = Math.max(40, this.clientWidth * 0.12);

        if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.suppressNextClick = true;
          this.showImage(deltaX < 0 ? 1 : 0);

          window.setTimeout(() => {
            this.suppressNextClick = false;
          }, 500);
        }

        this.resetPointer();
      }

      onLinkClick(event) {
        if (!this.suppressNextClick) return;

        event.preventDefault();
        event.stopPropagation();
        this.suppressNextClick = false;
      }

      onDragStart(event) {
        if (!this.mobileMediaQuery.matches) return;

        const point = event.touches?.[0] || event;
        if (this.isPointWithinGallery(point)) event.stopPropagation();
      }

      onViewportChange(event) {
        if (!event.matches) this.showImage(0);
      }

      resetPointer() {
        this.pointerStart = null;
      }

      isPointWithinGallery(point) {
        const bounds = this.getBoundingClientRect();

        return (
          point.clientX >= bounds.left &&
          point.clientX <= bounds.right &&
          point.clientY >= bounds.top &&
          point.clientY <= bounds.bottom
        );
      }

      showImage(index) {
        this.dataset.activeIndex = String(index);
      }
    },
  );
}
